import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  color: ${colors.secondary70};
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
  padding: 0 8px;
  white-space: nowrap;
`

const NoOptionsMessage = (props) => {
  return (
    <StyledWrapper>
      {props.selectProps.noOptionsMessage()}
    </StyledWrapper>
  )
}

NoOptionsMessage.propTypes = {
  selectProps: PropTypes.object,
}

export default NoOptionsMessage
